import axios from "axios";
import type { SupportedLanguage } from "@/data/api-layer/clientSettingsApi";
import type { Locale } from "vue-i18n";

export interface SupportedLanguageStudy extends SupportedLanguage {
   isPrimary: boolean;
}
export interface StudyResp {
   id: string;
   joiningFlowId: string;
   key: string;
   landingPage: any;
   title: string;
}

export type StudyStatus = "withdrawn" | "active" | "screened_out" | "pending";

export interface UserStudyResp {
   title: string;
   studyId: string;
   description: string;
   status: StudyStatus;
   startedAt: string | null;
   joiningFlowId: string | null;
   enrolledAt: string | null;
   withdrawnAt: string | null;
   screenedOutAt: string | null;
   completedAt: string | null;
   localeId: Locale;
}

export interface StudyWithdrawalReason {
   id: string;
   name: string;
   label: string;
   locale_id: Locale;
}

export interface WithdrawBody {
   withdrawal_reason_ids: string[];
   withdrawal_comments: string | null;
}

export default class StudiesAPI {
   public static getOne = async (key: string): Promise<StudyResp> => {
      const response = await axios.get(`/studies/by/key/${key}`);
      return response.data?.data;
   };
   public static getLocales = async (key: string): Promise<SupportedLanguageStudy[]> => {
      const response = await axios.get(`/studies/by/key/${key}/locales`);
      return response.data?.data;
   };

   public static getUserStudies = async (): Promise<UserStudyResp[]> => {
      const response = await axios.get(`/user/studies`);
      return response.data?.data;
   };

   public static getStudyWithdrawalReasons = async (): Promise<StudyWithdrawalReason[]> => {
      const response = await axios.get(`/studies/withdrawal-reasons`);
      return response.data?.data;
   };

   public static withdrawFromStudy = async (studyId: string, payload: WithdrawBody): Promise<void> => {
      await axios.post(`/studies/${studyId}/withdraw`, payload);
   };
}
